/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {animate, state, style, transition, trigger} from '@angular/animations';
import {Component, EventEmitter, HostBinding, Input, OnInit, Optional, Output, SkipSelf} from '@angular/core';
export class StackBlock implements OnInit {
      expanded: boolean = false;
     expandedChange: EventEmitter<boolean> = new EventEmitter<boolean>(false);
      expandable: boolean = false;
private _changedChildren: number = 0;
private _fullyInitialized: boolean = false;
private _changed: boolean = false;
/**
 * @return {?}
 */
get getChangedValue(): boolean {
        return this._changed || (this._changedChildren > 0 && !this.expanded);
    }
/**
 * @param {?} value
 * @return {?}
 */
set setChangedValue(value: boolean) {
        this._changed = value;

        if (this.parent && this._fullyInitialized) {
            if (value) {
                this.parent._changedChildren++;
            } else {
                this.parent._changedChildren--;
            }
        }
    }
/**
 * @param {?} parent
 */
constructor(
private parent: StackBlock) {
        if (parent) {
            parent.addChild();
        }
    }
/**
 * @return {?}
 */
ngOnInit(): void {
        // in order to access the parent StackBlock's properties,
        // the child StackBlock  has to be fully initialized at first.
        this._fullyInitialized = true;
    }
/**
 * @return {?}
 */
addChild(): void {
        this.expandable = true;
    }
/**
 * @return {?}
 */
toggleExpand(): void {
        if (this.expandable) {
            this.expanded = !this.expanded;
            this.expandedChange.emit(this.expanded);
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-stack-block",
    template: `
        <dt class="stack-block-label" (click)="toggleExpand()">
            <ng-content select="clr-stack-label"></ng-content>
        </dt>
        <dd class="stack-block-content">
            <ng-content></ng-content>
        </dd>
        <!-- FIXME: remove this string concatenation when boolean states are supported -->
        <div [@collapse]="''+!expanded" class="stack-children">
            <ng-content select="clr-stack-block"></ng-content>
        </div>
    `,
    // Custom elements are inline by default
    styles: [`
        :host { display: block; }
    `],
    // Make sure the host has the proper class for styling purposes
    host: {"[class.stack-block]": "true"},
    animations:
        [trigger("collapse",
                 [
                     state("true", style({"height": 0, "overflow-y": "hidden"})),
                     transition("true => false",
                                [animate("0.2s ease-in-out", style({"height": "*", "overflow-y": "hidden"}))]),
                     transition("false => true",
                                [style({"height": "*", "overflow-y": "hidden"}), animate("0.2s ease-in-out")])
                 ])]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: StackBlock, decorators: [{ type: SkipSelf }, { type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'expanded': [{ type: HostBinding, args: ["class.stack-block-expanded", ] },{ type: Input, args: ["clrSbExpanded", ] },],
'expandedChange': [{ type: Output, args: ["clrSbExpandedChange", ] },],
'expandable': [{ type: HostBinding, args: ["class.stack-block-expandable", ] },{ type: Input, args: ["clrSbExpandable", ] },],
'getChangedValue': [{ type: HostBinding, args: ["class.stack-block-changed", ] },],
'setChangedValue': [{ type: Input, args: ["clrSbNotifyChange", ] },],
};
}

function StackBlock_tsickle_Closure_declarations() {
/** @type {?} */
StackBlock.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StackBlock.ctorParameters;
/** @type {?} */
StackBlock.propDecorators;
/** @type {?} */
StackBlock.prototype.expanded;
/** @type {?} */
StackBlock.prototype.expandedChange;
/** @type {?} */
StackBlock.prototype.expandable;
/** @type {?} */
StackBlock.prototype._changedChildren;
/** @type {?} */
StackBlock.prototype._fullyInitialized;
/** @type {?} */
StackBlock.prototype._changed;
/** @type {?} */
StackBlock.prototype.parent;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
